var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var core = require('@sentry/core');
var helpers = require('../helpers.js');
var fetch = require('./fetch.js');

// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original license:

// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function promisifyRequest(request) {
  return new Promise(function (resolve, reject) {
    // @ts-expect-error - file size hacks
    request.oncomplete = request.onsuccess = function () {
      return resolve(request.result);
    };
    // @ts-expect-error - file size hacks
    request.onabort = request.onerror = function () {
      return reject(request.error);
    };
  });
}

/** Create or open an IndexedDb store */
function createStore(dbName, storeName) {
  var request = indexedDB.open(dbName);
  request.onupgradeneeded = function () {
    return request.result.createObjectStore(storeName);
  };
  var dbp = promisifyRequest(request);
  return function (callback) {
    return dbp.then(function (db) {
      return callback(db.transaction(storeName, 'readwrite').objectStore(storeName));
    });
  };
}
function keys(store) {
  return promisifyRequest(store.getAllKeys());
}

/** Insert into the end of the store */
function _push(store, value, maxQueueSize) {
  return store(function (store) {
    return keys(store).then(function (keys) {
      if (keys.length >= maxQueueSize) {
        return;
      }

      // We insert with an incremented key so that the entries are popped in order
      store.put(value, Math.max.apply(Math, _toConsumableArray(keys).concat([0])) + 1);
      return promisifyRequest(store.transaction);
    });
  });
}

/** Insert into the front of the store */
function _unshift(store, value, maxQueueSize) {
  return store(function (store) {
    return keys(store).then(function (keys) {
      if (keys.length >= maxQueueSize) {
        return;
      }

      // We insert with an decremented key so that the entries are popped in order
      store.put(value, Math.min.apply(Math, _toConsumableArray(keys).concat([0])) - 1);
      return promisifyRequest(store.transaction);
    });
  });
}

/** Pop the oldest value from the store */
function _shift(store) {
  return store(function (store) {
    return keys(store).then(function (keys) {
      var firstKey = keys[0];
      if (firstKey == null) {
        return undefined;
      }
      return promisifyRequest(store.get(firstKey)).then(function (value) {
        store.delete(firstKey);
        return promisifyRequest(store.transaction).then(function () {
          return value;
        });
      });
    });
  });
}
function createIndexedDbStore(options) {
  var store;

  // Lazily create the store only when it's needed
  function getStore() {
    if (store == undefined) {
      store = createStore(options.dbName || 'sentry-offline', options.storeName || 'queue');
    }
    return store;
  }
  return {
    push: function () {
      var _push2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(env) {
        var serialized;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return core.serializeEnvelope(env);
            case 3:
              serialized = _context.sent;
              _context.next = 6;
              return _push(getStore(), serialized, options.maxQueueSize || 30);
            case 6:
              _context.next = 10;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      function push(_x) {
        return _push2.apply(this, arguments);
      }
      return push;
    }(),
    unshift: function () {
      var _unshift2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(env) {
        var serialized;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return core.serializeEnvelope(env);
            case 3:
              serialized = _context2.sent;
              _context2.next = 6;
              return _unshift(getStore(), serialized, options.maxQueueSize || 30);
            case 6:
              _context2.next = 10;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 8]]);
      }));
      function unshift(_x2) {
        return _unshift2.apply(this, arguments);
      }
      return unshift;
    }(),
    shift: function () {
      var _shift2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var deserialized;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _shift(getStore());
            case 3:
              deserialized = _context3.sent;
              if (!deserialized) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", core.parseEnvelope(deserialized));
            case 6:
              _context3.next = 10;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
            case 10:
              return _context3.abrupt("return", undefined);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 8]]);
      }));
      function shift() {
        return _shift2.apply(this, arguments);
      }
      return shift;
    }()
  };
}
function makeIndexedDbOfflineTransport(createTransport) {
  return function (options) {
    var transport = createTransport(_objectSpread(_objectSpread({}, options), {}, {
      createStore: createIndexedDbStore
    }));
    helpers.WINDOW.addEventListener('online', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return transport.flush();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x3) {
        return _ref.apply(this, arguments);
      };
    }());
    return transport;
  };
}

/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */
function makeBrowserOfflineTransport() {
  var createTransport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetch.makeFetchTransport;
  return makeIndexedDbOfflineTransport(core.makeOfflineTransport(createTransport));
}
exports.createStore = createStore;
exports.makeBrowserOfflineTransport = makeBrowserOfflineTransport;
exports.push = _push;
exports.shift = _shift;
exports.unshift = _unshift;